// @ts-nocheck
import React, { Component, PropTypes } from 'react'
import FullWidthSection from '../FullWidthSection'
import RaisedButton from 'material-ui/RaisedButton'
import withWidth, { LARGE } from 'material-ui/utils/withWidth'
import typography from 'material-ui/styles/typography'
import lightBaseTheme from 'material-ui/styles/baseThemes/lightBaseTheme'
import { grey200, darkWhite } from 'material-ui/styles/colors'
import muiThemeable from 'material-ui/styles/muiThemeable'
import FontIcon from 'material-ui/FontIcon'

class Dashboard extends Component<any, any> {
  static propTypes = {
    width: PropTypes.number.isRequired
  }

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  homePageHero () {
    const styles = {
      root: {
        backgroundColor: this.props.muiTheme.palette.primary1Color,
        overflow: 'hidden'
      },
      svgLogo: {
        display: 'block',
        margin: '0 auto 150px',
        width: 520
      },
      tagline: {
        margin: '16px auto 0 auto',
        textAlign: 'center',
        maxWidth: 675
      },
      label: {
        color: lightBaseTheme.palette.primary1Color
      },
      githubStyle: {
        margin: '16px 32px 0px 8px'
      },
      h1: {
        color: darkWhite,
        fontWeight: typography.fontWeightLight
      },
      h2: {
        fontSize: 20,
        lineHeight: '28px',
        paddingTop: 19,
        marginBottom: 13,
        letterSpacing: 0
      },
      nowrap: {
        whiteSpace: 'nowrap'
      },
      taglineWhenLarge: {
        marginTop: 32
      },
      h1WhenLarge: {
        fontSize: 56
      },
      h2WhenLarge: {
        fontSize: 24,
        lineHeight: '32px',
        paddingTop: 16,
        marginBottom: 12
      }
    }

    styles.h2 = Object.assign({}, styles.h1, styles.h2)

    if (this.props.width === LARGE) {
      styles.tagline = Object.assign({}, styles.tagline, styles.taglineWhenLarge)
      styles.h1 = Object.assign({}, styles.h1, styles.h1WhenLarge)
      styles.h2 = Object.assign({}, styles.h2, styles.h2WhenLarge)
    }

    return (
      <FullWidthSection style={styles.root}>
        <img style={styles.svgLogo} src='/images/logo.svg' />
        <div style={styles.tagline}>
          <h2 style={styles.h1}>
            Administration
          </h2>
          <h2 style={styles.h2}>
            Content, membership and program management.
          </h2>
        </div>
      </FullWidthSection>
    )
  }

  homeContribute () {
    const styles = {
      root: {
        backgroundColor: grey200,
        textAlign: 'center'
      },
      h3: {
        margin: 0,
        padding: 0,
        fontWeight: typography.fontWeightLight,
        fontSize: 22
      },
      button: {
        margin: '52px 0 0'
      }
    }

    return (
      <FullWidthSection useContent style={styles.root}>
        <h3 style={styles.h3}>
          Want to help make this <span style={styles.nowrap}>project better? </span>
          <span style={styles.nowrap}>Submit issues and feedback via Usersnap.</span>
        </h3>
        <RaisedButton
          label='Usersnap'
          href='javascript:UserSnap.openReportWindow();'
          icon={<FontIcon className='fa fa-camera' />}
          style={styles.button}
        />
      </FullWidthSection>
    )
  }

  handleGetStarted = () => {
    this.context.router.push('/scheduling/assignments')
  }

  render () {
    return (
      <div>
        {this.homePageHero()}
        {this.homeContribute()}
      </div>
    )
  }
}

export default muiThemeable()(withWidth()(Dashboard))
